<template>
  <div class="terms-container">
    <div class="z11 uppercase">ARTFIELD.APP TERMS OF SERVICE AGREEMENT</div>
    <p class="z11">
      Welcome to Artfield.app. The following describes the terms under which artfield.app offers you access to its services.
    </p>
    <p class="z11">
      You must be at least 13 years old to become a Artfield.app member and/or use any Artfield.app services. In
      addition, before you can become a Artfield.app member and/or use the Artfield.app Web site if you are
      between the ages of 13 and 17, inclusive, you must obtain permission from your parent or guardian.
    </p>

    <p class="z11">
      If you want to become a Artfield.app member, please review this Terms of Service Agreement. By registering
      to become a Artfield.app member, clicking on the "I Agree" button and/or otherwise using the Artfield.app
      Web site you agree to the terms, conditions, notices and guidelines contained in this Terms of Service
      Agreement (“TOS”) and, where applicable, you represent that you have obtained permission from your parent
      or guardian.
    </p>

    <p class="z11">
      Please be advised that we may amend this Agreement at any time by posting the amended terms on our site. The
      amended terms shall be automatically effective immediately after they are initially posted on our site. This
      Agreement may not otherwise be amended except in a writing signed by both parties. This Agreement was last
      revised on October 1, 2024.
    </p>

    <div class="z11 uppercase">1. Description of Service</div>
    <p class="z11">
      Artfield.app provides a variety of free and paying online services including but not limited to professional
      directories and online portfolios accessible through various URL's including but not limited to
      https://artfield.app/ and its affiliate sites ("Artfield.app ", "this Web Site"," Artfield.app resources",
      "services"). These services are usable by all registered users and may be viewed by non-registered users, with
      the exception of the paying services that are limited to paying members only but may be viewed by non-registered
      users. Modeling agency scouts using the Artfield.app Agency Services (hereinafter "Professional Members") may
      also be able to view your online portfolio.
    </p>

    <p class="z11">
      Artfield.app is not a Talent Agency. Artfield.app does not represent you or its members as an agent, manager or
      otherwise. When you become a member, you gain access to the right to publish your online portfolio on Artfield.app.
      Your Artfield.app portfolio may be seen by Professional Members who use Artfield.app's services. Artfield.app does
      not offer services directly related to any member's future employment, and Artfield.app does not take any commissions
      or other fees from its members in connection with any employment a member might obtain.
    </p>

    <div class="z11 uppercase">2. Registration Obligations</div>
    <p class="z11">
      In order to use Artfield.app's resources, you must obtain access to the world wide web, pay any service fees associated
      with such access, and supply all equipment necessary to make a connection with the World Wide Web.
    </p>

    <p class="z11">
      By using any of Artfield.app's services, you agree to: (a) provide true, accurate, current and complete information
      about yourself as prompted by the service's registration form and (b) maintain and promptly update the registration
      data to keep it true, accurate, current and complete. Artfield.app has the right to suspend or terminate your account
      if you violate the above or Artfield.app has reason to believe that you have violated the above.
    </p>

    <div class="z11 uppercase">3. Age Requirement</div>
    <p class="z11">
      Artfield.app does not permit children under the age of 13 to become members, post any content or make use of online
      portfolios or any other members services without their parents permission. In addition, before you can become a
      Artfield.app member and/or use the Artfield.app Web site if you are between the ages of 13 and 17, inclusive, you
      must obtain permission from your parent or guardian.
    </p>

    <div class="z11 uppercase">4. Member Privacy</div>
    <p class="z11">
      It is Artfield.app's policy to respect the privacy of its members. Artfield.app will not monitor, edit, or disclose any
      personal information about you or your Artfield.app account, including its contents, without your prior permission unless
      Artfield.app has a good faith belief that such action is necessary to conform to legal requirements or comply with legal
      process; protect and defend the rights of Artfield.app; enforce the TOS; or act to protect the interest of its members or
      others. Artfield.app does provide certain user information in aggregate form to third parties, including its advertisers,
      for demographics.
    </p>

    <p class="z11">
      However, you agree that Artfield.app may access your account, including its contents, as stated above or to respond to service
      or technical issues.
    </p>

    <div class="z11 uppercase">4.1 Data Collection and Analytics</div>
    <p class="z11">
      Artfield.app collects certain personal and non-personal information when you use our services. This may include information you provide when creating your account (such as name, email, and contact details), content you upload, your IP address, browser type, device information, and browsing patterns. We also collect information through cookies and similar technologies to enhance your user experience and analyze usage patterns.
    </p>

    <p class="z11">
      We have integrated both Google Analytics and Facebook Analytics into our platform to better understand how users interact with our services. These integrations allow us to:
    </p>
    <ul class="z11 list-disc list-inside">
      <li>Track user behavior and engagement across our platform</li>
      <li>Analyze demographic information and usage patterns</li>
      <li>Measure the effectiveness of our content and features</li>
      <li>Optimize the user experience based on collected data</li>
    </ul>

    <p class="z11">Through Facebook Analytics, we may collect data about your interaction with our site when you are logged into Facebook. This data may include demographics, interests, and other information available through your Facebook profile that you have made accessible to applications.</p>
    <p class="z11">Through Google Analytics, we collect anonymous information about how you use our website, including pages visited, time spent on each page, referral sources, and technical information about your device and browser. Google Analytics may use cookies to track your session and link activity across different sessions and devices.</p>
    <p class="z11">
      The information we collect through these analytics platforms is used for various purposes, including:
    </p>
    <ul class="z11 list-disc list-inside">
      <li>Providing, operating, and maintaining our services</li>
      <li>Personalizing your experience on our platform</li>
      <li>Analyzing usage trends and optimizing our services</li>
      <li>Showing personalized content and advertisements based on your interests</li>
      <li>Communicating with you about updates, promotions, and opportunities</li>
      <li>Detecting and preventing fraudulent activities</li>
    </ul>
    <p class="z11">
      We may share aggregated, anonymized data with third-party advertisers to help them reach appropriate audiences. This data does not personally identify you but helps us deliver more relevant content and advertisements based on user demographics and interests.
    </p>
    <p class="z11">You can manage your privacy settings and opt out of certain data collection practices through your application settings in the Settings menu. For information collected through Facebook Analytics, you can also adjust your Facebook privacy settings to limit data sharing with third-party applications. For Google Analytics, you can install the Google Analytics Opt-out Browser Add-on to prevent your data from being collected by Google Analytics.</p>
    <div class="z11 uppercase">5. Member Conduct</div>
    <p class="z11">
      You understand and are aware that all information, data, text, software, music, sound, photographs, graphics, video, messages
      or other materials (hereinafter "content"), whether publicly posted or privately transmitted are the sole responsibility of the
      person from which such content originated. This means that you, and not Artfield.app, are entirely responsible for all content
      that you upload, post, or otherwise transmit via any Artfield.app's services. Artfield.app does not control the content posted
      on its services and therefore does not guarantee its accuracy, integrity or quality.
    </p>

    <p class="z11">
      (a) Any use of copyrighted, trademarked, patented, or otherwise service marked material without the express permission of the
      author or owner, the commission of any acts of copyright, trademark or any other intellectual property infringement, or
      contributing to, inducing, or facilitating such infringement.
    </p>

    <p class="z11">
      (b) Uploading, posting or otherwise transmitting any content that is unlawful, harmful, threatening, abusive, harassing,
      tortuous, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful or racially, ethnically or otherwise
      objectionable. This also includes content that promotes illegal activity in any way.
    </p>

    <!-- Repeat similar blocks for other sections -->
  </div>
</template>

<style scoped>
.z11:first-child {
  font-size: 20px;
}
.z11 {
  font-size: 16px;
  font-weight: 400;
  padding: 10px 0;
}

.uppercase {
  text-transform: uppercase;
  margin-top: 20px;
  line-height: 20px;
  letter-spacing: .4px;
}
</style>
